export var FolderableOperationValue;
(function (FolderableOperationValue) {
    FolderableOperationValue["OPEN"] = "open";
    FolderableOperationValue["SAVE_AS"] = "saveAs";
    FolderableOperationValue["SINGLE_SELECT"] = "singleSelect";
    FolderableOperationValue["MULTI_SELECT"] = "multiSelect";
})(FolderableOperationValue || (FolderableOperationValue = {}));
